module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<dl class="invoice-details"><dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Customer number:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( customer ))==null?'':__t)+
'</dd> ';
 if ( invoiceNumber ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Invoice number:" ) ))==null?'':__t)+
'</dt><dd>'+
((__t=( invoiceNumber ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( transientCounterInvoice ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Counter invoice:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Yes" ) ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( issued ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Issue date:" ) ))==null?'':__t)+
'</dt><dd>'+
((__t=( dateIssued ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Created date:" ) ))==null?'':__t)+
'</dt><dd>'+
((__t=( dateCreated ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( due ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Due date:" ) ))==null?'':__t)+
'</dt><dd>'+
((__t=( dateDue ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl><address class="invoice-customer-address"><span class="customer-name"><strong>'+
((__t=( customerName ))==null?'':__t)+
'</strong></span><br><span class="customer-address-1">'+
((__t=( customerAddr1 ))==null?'':__t)+
'</span><br> ';
 if ( customerAddr2 ) { 
__p+=' <span class="customer-address-2">'+
((__t=( customerAddr2 ))==null?'':__t)+
'</span><br> ';
 } 
__p+=' <span class="customer-post-code">'+
((__t=( customerPostCode ))==null?'':__t)+
'</span><span class="customer-city">'+
((__t=( customerCity ))==null?'':__t)+
'</span><br><span class="customer-country">'+
((__t=( customerCountry ))==null?'':__t)+
'</span></address><h5 class="'+
((__t=( classHeader ))==null?'':__t)+
'">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Invoice" ) ))==null?'':__t)+
' - '+
((__t=( termStatus ))==null?'':__t)+
'</h5><div class="usages table-wrap"><table><thead><tr><th>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Description" ) ))==null?'':__t)+
' </th><th class="num">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Quantity" ) ))==null?'':__t)+
' </th><th class="num">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Price" ) ))==null?'':__t)+
' </th><th class="num">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Sum" ) ))==null?'':__t)+
' </th><th class="num">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Total" ) ))==null?'':__t)+
' </th></tr></thead><tbody> ';
 usages.each( function( usage ) { 
__p+=' <tr><td>'+
((__t=( usage.getDescription() ))==null?'':__t)+
' </td><td class="num">'+
((__t=( usage.get( "transientNumber" ) ))==null?'':__t)+
' </td><td class="num">'+
((__t=( usage.get( "transientFormatPrice" ) ))==null?'':__t)+
' </td><td class="num">'+
((__t=( usage.get( "transientFormatAmount" ) ))==null?'':__t)+
' </td><td class="num">'+
((__t=( usage.get( "transientFormatTotal" ) ))==null?'':__t)+
' ';
 }); 
__p+=' </td></tr></tbody><tfoot><tr><td colspan="5" class="num"><dl><dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Subtotal:" ) ))==null?'':__t)+
'</dt><dd>'+
((__t=( transientFormatSumAmount ))==null?'':__t)+
'</dd> ';
 if ( vat === "" ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Tax:" ) ))==null?'':__t)+
'</dt> ';
 }  else { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Tax (%s):" ).format(vat) ))==null?'':__t)+
'</dt> ';
 } 
__p+=' <dd>'+
((__t=( transientFormatSumVat ))==null?'':__t)+
'</dd><dt><strong>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Total:" ) ))==null?'':__t)+
'</strong></dt><dd><strong>'+
((__t=( transientFormatSumTotal ))==null?'':__t)+
'</strong></dd> ';
 if ( transientFormatSumCounterInvoices ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Conceeded:" ) ))==null?'':__t)+
'</dt><dd>'+
((__t=( transientFormatSumCounterInvoices ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></td></tr></tfoot></table></div><fieldset class="button-wrap"><button data-click="update-cancel">'+
((__t=( i18n.tc( "InvoiceUpdateform", "Cancel" ) ))==null?'':__t)+
'</button> ';
 if ( transientCounterInvoice ) { 
__p+=' <button data-click="update-counter-invoice">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Original invoice" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 if ( ! transientCounterInvoice && isTechSupport ) { 
__p+=' <button data-click="update-create-usage">'+
((__t=( i18n.tc( "InvoiceUpdateForm", "Create usage" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' </fieldset>';
}
return __p;
};
